import { css } from "@emotion/react";
import { FormDefinition, formDefinition } from "./from-definition";
import React from "react";
import { TextAreaWithCharacterLimit } from "./TextAreaWithCharacterLimit";
import { FormFieldInputElement } from "./FormFieldInputElement";

export function PDPGiftCardMessage(props: {
  formDefinition: Array<FormDefinition>,
  formState: Map<string, string>;
  setFormFieldValue: (id: string) => (v: string) => void;
}) {
  return (
    <form
      css={css`
        display: flex;
        flex-direction: column;
        gap: 10px;
      `}
    >
      {props.formDefinition.map(formField => {
        const setFormFieldValue = props.setFormFieldValue(formField.id);

        if (formField.type === "text") {
          return (
            <FormFieldInputElement
              key={formField.id}
              formField={formField}
              value={props.formState.get(formField.id) || ""}
              setValue={setFormFieldValue}
            />
          );
        } else if (formField.type === "long-text") {
          return (
            <TextAreaWithCharacterLimit
              key={formField.id}
              formField={formField}
              value={props.formState.get(formField.id) || ""}
              setValue={setFormFieldValue}
            />
          );
        } else {
          const _: never = formField;

          return null;
        }
      })}
    </form>
  );
}
